import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { RdSAPLookUpCodesService } from '../../../rdsap/services/configuration/rdsap-lookup-codes.service';
import { RdSAPLookupCodeDtoV0 } from '../../../rdsap/models/rdsap/rdSAPLookupCodeDtoV0';

// Define the custom data service
// this service overrides the @ngrx/data default data service and fetches data with custom services
@Injectable()
export class RdSAPLookUpCodesDataService extends DefaultDataService<RdSAPLookupCodeDtoV0> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    private rdSAPLookUpCodesService: RdSAPLookUpCodesService
  ) {
    super('RdSAPLookUpCodes', http, httpUrlGenerator);
  }

  getAll(): Observable<RdSAPLookupCodeDtoV0[]> {
    return this.rdSAPLookUpCodesService.getRdSAPLookUpCodesData().pipe(
      map(data => [data]) // Wrap data in an array as NgRx Data expects an array
    );
  }
}
